import ACTIONS from "../../constants/actions";

const initialState = {
	populars   : {
		leagues  : [],
		sports   : [],
		populars : [],
		fetching : true
	},
	lineWidget : {
		sports   : [],
		fetching : true
	},
};

export default function line(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.LINE.GET_POPULAR: {
			const newState = {
				populars : {...action.data, fetching : false}
			};
			return Object.assign({}, {...state, ...newState});
		}

		case ACTIONS.LINE.GET_LINE : {
			const newState = {
				lineWidget : {...action.data, fetching : false}
			};

			return Object.assign({}, {...state, ...newState});
		}


		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/line.js